import { useState } from "react";
import "@/App.css";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1656122381069-9ec666d95cf1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxzdW4tZHJlbmNoZWQlMjBpbW1hY3VsYXRlJTIwbGl2aW5nJTIwcm9vbSUyMHdvb2QlMjBmbG9vcnN8ZW58MHx8fHwxNzkwMzYzMTI3fDA&ixlib=rb-4.1.0&q=85";


function Nav() {
  return (
    <header className="sticky top-0 z-40 bg-[#FAF8F5]/90 backdrop-blur-md border-b border-[#E8E1D5]">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
        <a href="#hero" className="flex flex-col" data-testid="nav-logo">
          <span className="font-heading text-xl font-bold tracking-tight text-[#2D4030]">
            Francisco Gamez Home Care
          </span>
          <span className="text-[10px] tracking-wider uppercase text-[#6E6862]">
            By Francisco Gamez &bull; Residential Cleaning
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-7 text-sm font-medium text-[#4D4741]">
          <a href="#services" className="hover:text-[#C26D45] transition-colors" data-testid="nav-services-link">Services</a>
          <a href="#ethos" className="hover:text-[#C26D45] transition-colors" data-testid="nav-ethos-link">Owner Ethos</a>
          <a href="#reviews" className="hover:text-[#C26D45] transition-colors" data-testid="nav-reviews-link">Reviews</a>
        </nav>
        <div className="flex items-center gap-3">
          <a href="tel:323-245-5294" className="hidden sm:inline-block text-xs font-semibold px-4 py-2 text-[#2D4030] bg-[#EFE9DF] rounded-full hover:bg-[#E4DBCF] transition-colors" data-testid="nav-call-button">
            Call 323-245-5294
          </a>
          <a href="#contact" className="inline-flex items-center justify-center px-5 py-2.5 text-xs font-semibold uppercase tracking-wider text-white bg-[#C26D45] rounded-full hover:bg-[#9E5230] transition-colors shadow-sm" data-testid="nav-book-button">
            Book Appointment
          </a>
        </div>
      </div>
    </header>
  );
}

function Hero() {
  return (
    <section id="hero" className="py-16 md:py-24 px-6 max-w-6xl mx-auto" data-testid="hero-section">
      <div className="grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 reveal-entry">
          <div className="inline-block px-3 py-1 rounded-full bg-[#EFE9DF] text-[#6E6862] text-xs font-medium tracking-wide mb-6">
            Dedicated Residential Housekeeping
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight text-[#2D4030] leading-[1.12] mb-6" data-testid="hero-headline">
            Thoughtful care for your home.
          </h1>
          <p className="text-base sm:text-lg text-[#5E574F] leading-relaxed mb-8 max-w-xl" data-testid="hero-subcopy">
            Francisco Gamez delivers warm, reliable, and deeply thorough in-home cleaning. From high-touch
            surface sanitization to complete room turnovers, experience true peace of mind.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a href="#contact" className="px-8 py-4 bg-[#C26D45] text-white text-xs font-semibold uppercase tracking-wider rounded-full hover:bg-[#9E5230] transition-all text-center shadow-md" data-testid="hero-consultation-button">
              Request In-Home Consultation
            </a>
            <a href="tel:323-245-5294" className="px-8 py-4 bg-white text-[#2D4030] text-xs font-semibold uppercase tracking-wider rounded-full border border-[#D9D0C1] hover:bg-[#FAF8F5] transition-all text-center" data-testid="hero-call-button">
              Call 323-245-5294 &rarr;
            </a>
          </div>
          <div className="mt-10 pt-6 border-t border-[#E8E1D5] flex flex-wrap items-center gap-3 sm:gap-6 text-xs text-[#6E6862]">
            <div>
              Direct Owner Line:{" "}
              <a href="tel:323-245-5294" className="font-semibold text-[#2D4030]" data-testid="hero-phone">323-245-5294</a>
            </div>
            <div className="hidden sm:block">&bull;</div>
            <div>
              Operator: <span className="font-semibold text-[#2D4030]" data-testid="hero-owner">Francisco Gamez</span>
            </div>
          </div>
        </div>
        <div className="lg:col-span-5">
          <div className="relative rounded-3xl overflow-hidden aspect-[4/5] shadow-lg border border-[#E0D7C7]" data-testid="hero-image-frame">
            <img src={HERO_IMAGE} alt="Sun-drenched immaculate living room with polished wood floors" className="absolute inset-0 w-full h-full object-cover" />
            <div className="relative h-full p-6 flex flex-col justify-between">
              <div className="bg-white/85 backdrop-blur-md px-3.5 py-1.5 rounded-full text-xs font-semibold text-[#2D4030] self-start border border-white/60">
                Francisco Gamez In-Home Care
              </div>
              <div className="bg-white/90 backdrop-blur-md p-5 rounded-2xl border border-white/80 shadow-sm">
                <div className="text-xs font-bold text-[#2D4030] mb-1">Guaranteed Cleanliness Standard</div>
                <p className="text-[11px] text-[#5E574F] leading-normal">
                  "Every corner dusted, every floor polished, every room restored to calm."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const SERVICES = [
  {
    title: "Complete Deep Clean",
    desc: "Detailed scrubbing from ceiling corners to floor moldings. Ideal for spring cleaning or pre-event preparations.",
    items: ["Deep oven & microwave clean", "Window track & sill wipe down", "Calcium deposit removal on fixtures"],
    cta: "Book Deep Clean",
    popular: false,
  },
  {
    title: "Recurring Home Maintenance",
    desc: "Weekly or bi-weekly visits maintaining pristine order, allergen-free air, and freshly turned beds.",
    items: ["Full vacuuming & hardwood washing", "Kitchen counter sanitization", "Bath & shower disinfectant wash"],
    cta: "Set Recurring Schedule",
    popular: true,
  },
  {
    title: "Move-In / Out Turnover",
    desc: "Flawless move handovers designed to protect rental deposits and welcome new owners into immaculate spaces.",
    items: ["Interior cabinets & drawers", "Wall spot wipe down", "Closet shelf sanitizing"],
    cta: "Schedule Turnover",
    popular: false,
  },
];

function Services() {
  return (
    <section id="services" className="py-24 px-6 max-w-6xl mx-auto" data-testid="services-section">
      <div className="max-w-2xl mb-16">
        <span className="text-xs font-bold uppercase tracking-widest text-[#C26D45]">Our Cleaning Care</span>
        <h2 className="font-heading text-3xl sm:text-4xl font-bold text-[#2D4030] mt-2">
          Customized options for every household.
        </h2>
      </div>
      <div className="grid md:grid-cols-3 gap-8">
        {SERVICES.map((s, i) => (
          <div
            key={s.title}
            className={`bg-white p-8 rounded-3xl flex flex-col justify-between ${
              s.popular
                ? "border-2 border-[#2D4030] shadow-md"
                : "border border-[#E8E1D5] shadow-xs hover:border-[#C26D45]/50 transition-colors"
            }`}
            data-testid={`service-card-${i}`}
          >
            <div>
              {s.popular && (
                <div className="inline-block px-3 py-0.5 rounded-full bg-[#2D4030] text-white text-[10px] font-bold uppercase tracking-wider mb-4">
                  Most Popular
                </div>
              )}
              <h3 className="font-heading text-xl font-bold text-[#2D4030] mb-3">{s.title}</h3>
              <p className="text-xs sm:text-sm text-[#5E574F] leading-relaxed mb-6">{s.desc}</p>
              <ul className="text-xs text-[#6E6862] space-y-2 mb-8">
                {s.items.map((it) => (
                  <li key={it} className="flex items-center gap-2">&bull; {it}</li>
                ))}
              </ul>
            </div>
            <a href="#contact" className="text-xs font-bold uppercase tracking-wider text-[#C26D45] hover:text-[#9E5230]" data-testid={`service-cta-${i}`}>
              {s.cta} &rarr;
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}

const ETHOS_CARDS = [
  { title: "Direct Accountability", desc: "Speak directly with Francisco before and after each cleaning session." },
  { title: "Safe Chemistry", desc: "Eco-conscious cleaning products gentle on pets, children, and stone surfaces." },
  { title: "Punctual & Reliable", desc: "Respect for your morning schedule and family time." },
  { title: "Transparent Pricing", desc: "Straightforward rates with zero unexpected upsells." },
];

function Ethos() {
  return (
    <section id="ethos" className="py-20 px-6 bg-[#EFE9DF]/50 border-t border-[#E8E1D5]" data-testid="ethos-section">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-6">
            <span className="text-xs font-bold uppercase tracking-widest text-[#C26D45]">Personal Integrity</span>
            <h2 className="font-heading text-3xl font-bold text-[#2D4030] mt-2 mb-4">
              Cleaning done with pride and care.
            </h2>
            <p className="text-sm text-[#5E574F] leading-relaxed mb-4">
              "When you invite someone into your home, trust is everything. I treat every property as if it were
              my own family's sanctuary."
            </p>
            <div className="text-xs font-semibold text-[#2D4030]">&mdash; Francisco Gamez, Owner & Operator</div>
          </div>
          <div className="md:col-span-6 grid grid-cols-1 sm:grid-cols-2 gap-4 text-xs">
            {ETHOS_CARDS.map((c) => (
              <div key={c.title} className="bg-white p-5 rounded-2xl border border-[#D9D0C1]" data-testid={`ethos-card-${c.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <div className="font-bold text-[#2D4030] text-sm mb-1">{c.title}</div>
                <p className="text-[#5E574F]">{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function Reviews() {
  return (
    <section id="reviews" className="py-20 px-6 max-w-6xl mx-auto" data-testid="reviews-section">
      <div className="max-w-xl mb-12">
        <span className="text-xs font-bold uppercase tracking-widest text-[#C26D45]">Client Notes</span>
        <h2 className="font-heading text-3xl font-bold text-[#2D4030] mt-2">What our clients say.</h2>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        <div className="bg-[#FAF2EB] p-6 rounded-2xl border border-dashed border-[#DEBAA6]" data-testid="review-placeholder-1">
          <div className="text-xs font-bold uppercase tracking-wider text-[#C26D45] mb-2">Client Review</div>
          <p className="text-xs text-[#5E574F] leading-relaxed">
            Our first client reviews will appear here soon — every review shown will be from a real customer.
          </p>
        </div>
        <div className="bg-[#FAF2EB] p-6 rounded-2xl border border-dashed border-[#DEBAA6]" data-testid="review-placeholder-2">
          <div className="text-xs font-bold uppercase tracking-wider text-[#C26D45] mb-2">Client Review</div>
          <p className="text-xs text-[#5E574F] leading-relaxed">
            Space reserved for genuine feedback from households Francisco cares for.
          </p>
        </div>
        <div className="bg-[#FAF2EB] p-6 rounded-2xl border border-dashed border-[#DEBAA6]" data-testid="review-feedback-card">
          <div className="text-xs font-bold uppercase tracking-wider text-[#C26D45] mb-2">Leave Your Feedback</div>
          <p className="text-xs text-[#5E574F] mb-4 leading-relaxed">
            We invite all clients to share their experience. Book a service and let us make your home shine.
          </p>
          <a href="#contact" className="text-xs font-bold uppercase tracking-wider text-[#C26D45] hover:text-[#9E5230]" data-testid="review-book-button">
            Book Your Appointment &rarr;
          </a>
        </div>
      </div>
    </section>
  );
}

function Contact() {
  const [form, setForm] = useState({ name: "", phone: "", service_type: "Deep Cleaning", details: "" });
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  // Netlify Forms: the matching hidden form lives in public/index.html so Netlify detects it at deploy time.
  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) return;
    setStatus("sending");
    try {
      const res = await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ "form-name": "quote", ...form }).toString(),
      });
      if (!res.ok) throw new Error("failed");
      setStatus("success");
    } catch {
      setStatus("error");
    }
  };

  return (
    <section id="contact" className="py-24 px-6 bg-[#2D4030] text-white" data-testid="contact-section">
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-12 gap-12 items-center">
          <div className="md:col-span-5 space-y-6">
            <span className="text-xs uppercase tracking-widest text-[#B5CEB8] font-bold">Contact Francisco</span>
            <h2 className="font-heading text-3xl sm:text-4xl font-bold leading-tight text-white">
              Ready for a spotless home?
            </h2>
            <p className="text-sm text-[#D7E3D8] leading-relaxed">
              Fill out the request form or reach out directly by phone. Francisco will personally reply with
              available scheduling slots.
            </p>
            <div className="pt-4 border-t border-white/15 space-y-3 text-xs">
              <div className="flex items-center gap-3">
                <span className="text-[#B5CEB8] uppercase tracking-wider w-24">Direct Line:</span>
                <a href="tel:323-245-5294" className="font-bold text-white text-sm" data-testid="contact-phone">323-245-5294</a>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-[#B5CEB8] uppercase tracking-wider w-24">Owner:</span>
                <span className="font-medium text-white" data-testid="contact-owner">Francisco Gamez</span>
              </div>
            </div>
          </div>

          <div className="md:col-span-7 bg-white text-[#2C2926] p-8 md:p-10 rounded-3xl shadow-xl">
            {status === "success" ? (
              <div className="text-center py-10 space-y-4" data-testid="form-success-message">
                <div className="font-heading text-2xl font-bold text-[#2D4030]">Request sent!</div>
                <p className="text-sm text-[#5E574F]">
                  Thank you, {form.name.split(" ")[0]}. Francisco will personally reach out to you at{" "}
                  <span className="font-semibold">{form.phone}</span> shortly.
                </p>
                <button
                  onClick={() => { setStatus("idle"); setForm({ name: "", phone: "", service_type: "Deep Cleaning", details: "" }); }}
                  className="text-xs font-bold uppercase tracking-wider text-[#C26D45] hover:text-[#9E5230]"
                  data-testid="form-reset-button"
                >
                  Send another request
                </button>
              </div>
            ) : (
              <form className="space-y-4" onSubmit={submit} data-testid="lead-form">
                <div>
                  <label className="block text-xs font-semibold uppercase text-[#5E574F] mb-1" htmlFor="lead-name">Your Name</label>
                  <input id="lead-name" type="text" required placeholder="Full Name" value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    className="w-full px-4 py-3 rounded-xl border border-[#D9D0C1] bg-[#FAF8F5] text-sm focus:outline-none focus:border-[#C26D45]"
                    data-testid="lead-name-input" />
                </div>
                <div className="grid sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-semibold uppercase text-[#5E574F] mb-1" htmlFor="lead-phone">Phone Number</label>
                    <input id="lead-phone" type="tel" required placeholder="323-000-0000" value={form.phone}
                      onChange={(e) => setForm({ ...form, phone: e.target.value })}
                      className="w-full px-4 py-3 rounded-xl border border-[#D9D0C1] bg-[#FAF8F5] text-sm focus:outline-none focus:border-[#C26D45]"
                      data-testid="lead-phone-input" />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold uppercase text-[#5E574F] mb-1" htmlFor="lead-service">Service Type</label>
                    <select id="lead-service" value={form.service_type}
                      onChange={(e) => setForm({ ...form, service_type: e.target.value })}
                      className="w-full px-4 py-3 rounded-xl border border-[#D9D0C1] bg-[#FAF8F5] text-sm focus:outline-none focus:border-[#C26D45]"
                      data-testid="lead-service-select">
                      <option>Deep Cleaning</option>
                      <option>Recurring Maintenance</option>
                      <option>Move-In / Move-Out</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label className="block text-xs font-semibold uppercase text-[#5E574F] mb-1" htmlFor="lead-details">Home Details</label>
                  <textarea id="lead-details" rows="3" placeholder="Number of bedrooms/bathrooms, preferred cleaning date..." value={form.details}
                    onChange={(e) => setForm({ ...form, details: e.target.value })}
                    className="w-full px-4 py-3 rounded-xl border border-[#D9D0C1] bg-[#FAF8F5] text-sm focus:outline-none focus:border-[#C26D45]"
                    data-testid="lead-details-textarea" />
                </div>
                {status === "error" && (
                  <p className="text-xs text-red-600 text-center" data-testid="form-error-message">
                    Something went wrong — please call 323-245-5294 directly.
                  </p>
                )}
                <button type="submit" disabled={status === "sending"}
                  className="w-full py-4 bg-[#C26D45] disabled:opacity-60 text-white text-xs font-semibold uppercase tracking-wider rounded-xl hover:bg-[#9E5230] transition-colors shadow"
                  data-testid="lead-submit-button">
                  {status === "sending" ? "Sending..." : "Send Quote Request to Francisco"}
                </button>
                <p className="text-[11px] text-center text-[#6E6862]">
                  Fast response &bull; Direct quote from Francisco Gamez
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer className="bg-[#1D2B20] text-[#9FB3A2] py-12 px-6 border-t border-white/10 text-xs" data-testid="footer">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <div className="font-heading text-white text-base font-bold">Francisco Gamez Home Care</div>
          <div className="mt-1">In-home cleaning services by Francisco Gamez &bull; 323-245-5294</div>
        </div>
        <div className="flex flex-wrap gap-6 text-xs text-[#D7E3D8]">
          <a href="#services" className="hover:text-white transition-colors">Services</a>
          <a href="#ethos" className="hover:text-white transition-colors">Ethos</a>
          <a href="#reviews" className="hover:text-white transition-colors">Reviews</a>
          <a href="#contact" className="hover:text-white transition-colors">Contact</a>
        </div>
        <div className="text-right text-[11px] text-[#7E9682]">Professional Residential Cleaning Services</div>
      </div>
    </footer>
  );
}

export default function App() {
  return (
    <div className="antialiased bg-[#FAF8F5] text-[#2C2926]" data-testid="home-page">
      <Nav />
      <Hero />
      <Services />
      <Ethos />
      <Reviews />
      <Contact />
      <Footer />
    </div>
  );
}
